module.exports = __webpack_public_path__ + "static/media/IMG_8804.b1b06ec5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/vertical/IMG_8804.jpg
// module id = 164
// module chunks = 0